// src/routes/index.jsx
import { createBrowserRouter } from 'react-router-dom';
import Top100Page from '../pages/top100';
import HomePage from '../pages/home';
import FAQPage from '../pages/faq';
import NotFound from '../pages/404';
import BadgesPage from '../pages/badges';
import MintPage from '../pages/mint';

import ContactPage from '../pages/contact';
import MarksCalculatorPage from '../pages/calculator';
import TechnicalMaintenance from '../pages/maintenance';
import TabbedPage from '../pages/check-rank';
import PartnershipPage from '../pages/partnership';
import InfoPage from '../pages/info';
import ReportsPage from '../pages/reports';

const router = createBrowserRouter([
	{ path: "/", element: <HomePage /> },
	{ path: "/check-marks-rank", element: <TabbedPage /> },
	{ path: "/reports", element: <ReportsPage /> },
	{ path: "/check-badges-rank", element: <TabbedPage /> },
	{ path: "/check-custom-rank", element: <TabbedPage /> },
	{ path: "/scroll-canvas-badges", element: <BadgesPage /> },
	{ path: "/top100", element: <Top100Page /> },
	{ path: "/faq", element: <FAQPage /> },
	{ path: "/mint-key", element: <MintPage /> },
	{ path: "/my-keys", element: <MintPage /> },
	{ path: "/info", element: <InfoPage /> },
	{ path: "/partnership", element: <PartnershipPage /> },
	{ path: "/contact", element: <ContactPage /> },
	{ path: "/scroll-marks-calculator", element: <MarksCalculatorPage /> },
	{ path: "/maintenance", element: <TechnicalMaintenance /> },
	{ path: "*", element: <NotFound /> },
]);

export default router;
